import { render, staticRenderFns } from "./multi-select-with-search.vue?vue&type=template&id=48a77afc&scoped=true&"
import script from "./multi-select-with-search.vue?vue&type=script&lang=js&"
export * from "./multi-select-with-search.vue?vue&type=script&lang=js&"
import style0 from "./multi-select-with-search.vue?vue&type=style&index=0&id=48a77afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a77afc",
  null
  
)

component.options.__file = "multi-select-with-search.vue"
export default component.exports